import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { useQueryClient } from '@tanstack/react-query'
import { AuthQueryKey } from '../../keys'

export default function useLogout() {
	const queryClient = useQueryClient()
	const navigate = useNavigate()

	return useCallback(() => {
		localStorage.removeItem('token')
		localStorage.removeItem('role')

		queryClient.resetQueries({
			queryKey: [AuthQueryKey.Profile],
		})

		navigate('/login', { replace: true })
	}, [navigate, queryClient])
}
